/** @format */

export class SSO {}
